import { Option, IFilter } from '../../../blocks.app/searchbar/Filter/Filter-types'
import translate from '../../translate'
import { api } from '../../api/ConnectionManager'
import moment from 'moment'
import helpers from 'core/helpers'
import { getURLSearchParamsByLocation } from 'features/routes/utils'
import coreHelpers from '../index'
import { Location } from 'history'
import { AdvancedSearchInterface, AdvancedSearchQuery } from '../../models/AdvancedSearch'
import { FilterQuery } from '../../../blocks.app/searchbar/Filter/Filter-types'

export const getCompatibleFilters = async (
    filters: IFilter[],
    location: Location,
    type: string,
    advancedSearch: AdvancedSearchQuery = {}
): Promise<IFilter[]> => {
    const query = helpers.getQuery(getURLSearchParamsByLocation(location), type).query
    const adSearch = advancedSearch ? advancedSearch : {}

    if (type === 'broadcasts') {
        const response: unknown = await api.send('getBroadcastsFilters', {
            appliedFilters: filters,
            utcOffsetM: moment().utcOffset(),
        })

        return Array.isArray(response) ? (response as IFilter[]) : []
    }

    const response: unknown = await api.send('getDsAndGroupFilters', {
        appliedFilters: filters,
        utcOffsetM: moment().utcOffset(),
        advancedSearch: {
            query: query ? query : '',
            ...adSearch,
        },
    })

    return Array.isArray(response) ? (response as IFilter[]) : []
}

export const getValidNameLabel = (option: Option, translateQ: boolean | undefined) => {
    const label = translateQ ? translate(option.label.toString()) : option.label

    return option.value === null || option.value === '' ? translate('filterOptionUnknown') : label
}

const parseParams = (serializedFilters: string): IFilter[] => {
    let result: unknown = []

    try {
        result = JSON.parse(serializedFilters)
    } catch (e) {
        console.log(e)
    }

    return Array.isArray(result) ? (result as IFilter[]) : []
}

export const appliedFiltersFromQuery = (availableFilters: IFilter[], location: Location, type: string) => {
    const locationQuery = getURLSearchParamsByLocation(location)
    const query = coreHelpers.getQuery(locationQuery, type)
    const appliedFilters: IFilter[] = []
    const filterList = query.filterList ? parseParams(query.filterList) : []

    if (filterList) {
        filterList.forEach((filter) => {
            const availableFilter = availableFilters.find((item: IFilter) => filter.name === item.name)
            const availableOptions = availableFilter ? availableFilter.options : []
            const options = availableOptions.map((option: Option) => {
                return {
                    ...option,
                    selected: filter.options.some((item) => option.label === item.label && item.selected),
                }
            })

            if (options.length) {
                appliedFilters.push({
                    name: filter.name,
                    type: filter.type,
                    translateOptionsQ: availableFilter ? availableFilter.translateOptionsQ : false,
                    options,
                })
            }
        })
    }

    return appliedFilters
}

export const getFiltersFromQuery = (_availableFilters: IFilter[], location: Location, type: string): IFilter[] => {
    const locationQuery = getURLSearchParamsByLocation(location)
    const query = coreHelpers.getQuery(locationQuery, type)
    const filterList = query.filterList ? parseParams(query.filterList) : []

    return filterList
}

export const onApplyFilterToQuery = (
    filteredArray: IFilter[],
    advancedSearch?: AdvancedSearchInterface
): FilterQuery => {
    const filterToQuery: IFilter[] = []
    const data: FilterQuery = {}
    const advancedSearchList: AdvancedSearchQuery = {}

    filteredArray.forEach((filter) => {
        filterToQuery.push({
            name: filter.name,
            type: filter.type,
            options: getSelectedOptions(filter.options),
        })
    })

    data.filterList = JSON.stringify(filterToQuery)

    if (advancedSearch && advancedSearch.enabledQ) {
        advancedSearchList.operator = advancedSearch.operator

        if (advancedSearch.exactly.activeQ) {
            advancedSearchList.separator = advancedSearch.exactly.separator
        }

        data.advancedSearch = JSON.stringify(advancedSearchList)
    }

    if (!filterToQuery.length) {
        delete data.filterList
    }

    return data
}

const getSelectedOptions = (options: Option[]) => {
    return options.filter((option) => option.selected)
}

export const getSomeValues = (filter: IFilter) => {
    let valuesString = ''
    const keys: string[] = []

    filter.options.forEach((option: Option) => {
        if (option.selected) {
            keys.push(getValidNameLabel(option, filter.translateOptionsQ))
        }
    })

    valuesString = keys.length > 2 ? keys.slice(0, 2).join(', ') + ' и еще' : keys.slice().join(', ')

    return valuesString ? valuesString : translate(filter.name)
}
